import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  breadcrumbLabel: {
    fontWeight: 500,
  },
  listsContainer: {
    maxHeight: '240px',
    overflowY: 'auto',
  },
}));

export default useStyles;
